import React from 'react';
// Removido o 'Link' que não era necessário aqui
import Button from '../ui/Button';

const HeroSection = () => {
  // Função para rolar suavemente para a secção de planos
  const handleScrollToPlans = (event) => {
    event.preventDefault(); // Previne o comportamento padrão do link
    const plansSection = document.getElementById('planos');
    if (plansSection) {
      plansSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <section
      id="home"
      className="on-navy bg-rn-navy bg-pattern py-20 lg:py-32 text-center text-white"
    >
      <div className="container mx-auto px-6">
        <p className="eyebrow text-rn-orange mb-4">RNPlugin para Civil 3D e AutoCAD</p>
        <h1 className="text-[36px] md:text-[48px] lg:text-[56px] font-semibold leading-[1.15] mb-4">
          Sua Rotina de Projetos <br className="hidden md:inline" />
          <span className="text-rn-orange">Automatizada</span>
        </h1>
        <p className="text-lg md:text-xl text-rn-text-soft-dk mb-8 max-w-2xl mx-auto">
          O plugin de automação para o Civil 3D e AutoCAD feito para quem projeta.
        </p>

        {/* O botão agora chama a nossa função de rolagem */}
        <Button size="lg" onClick={handleScrollToPlans}>
          Melhore seu Projeto Agora
        </Button>

        {/* Diferenciais */}
        <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-8 max-w-4xl mx-auto">
          <div className="text-center">
            <div className="text-xl font-semibold text-rn-orange mb-2">Foco em projetos</div>
            <div className="text-rn-text-soft-dk">Rodovia, ferrovia, loteamento, topografia e outras obras complexas no Civil 3D.</div>
          </div>
          <div className="text-center">
            <div className="text-xl font-semibold text-rn-orange mb-2">Feito por quem projeta</div>
            <div className="text-rn-text-soft-dk">Cada comando nasce de um problema real de obra.</div>
          </div>
          <div className="text-center">
            <div className="text-xl font-semibold text-rn-orange mb-2">Evolui toda semana</div>
            <div className="text-rn-text-soft-dk">Comandos novos toda semana, direto na sua licença.</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
